'use client';

import { createContext, useContext } from 'react';

export type TranslationContextType = {
  title: string;
  description: string;
  language: {
    english: string;
    japanese: string;
  };
  form: {
    email: string;
    firstName: string;
    lastName: string;
    subscribe: string;
    thankYou: string;
    error: string;
    validation: {
      required: string;
      invalidEmail: string;
    };
  };
};

export const TranslationContext = createContext<TranslationContextType | null>(null);

export function useTranslations() {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslations must be used within a TranslationProvider');
  }
  return context;
}
